import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de récupération du tabagisme";
const DESCRIPTION =
  "Calculatrice de récupération du tabagisme en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de récupération du tabagisme, calculatrice de récupération du tabagisme, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/smoking-recovery-calculator/";

function SmokingRecoveryCalculator() {
  const [smokePerDay, setSmokePerDay] = useState(0);
  const [smokingDuration, setSmokingDuration] = useState(0);
  const [quitDate, setQuitDate] = useState(new Date());
  const [result, setResult] = useState();
  const [error, setError] = useState("");

  const frenchWeekdays = [
    "Dimanche",
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
  ];

  const formatDate = (date) => {
    const day = frenchWeekdays[date.getDay()];
    const month = date.getMonth() + 1;
    const dayOfMonth = date.getDate();
    const year = date.getFullYear();
    return `${day}, ${dayOfMonth}-${month}-${year}`;
  };

  const handleCalculate = () => {
    try {
      const cigarettesPerDay = parseInt(smokePerDay);
      const lifeGain = Math.floor((cigarettesPerDay / 10) * 5);

      const heartRateDropDate = new Date(quitDate);
      heartRateDropDate.setDate(quitDate.getDate() + 1);

      const anxietyDate = new Date(heartRateDropDate);
      anxietyDate.setDate(heartRateDropDate.getDate() + 2);

      const symptomsDiminishDate = new Date(anxietyDate);
      symptomsDiminishDate.setDate(anxietyDate.getDate() + 14);

      const symptomsDisappearDate = new Date(symptomsDiminishDate);
      symptomsDisappearDate.setDate(symptomsDiminishDate.getDate() + 14);

      setResult({
        lifeGain,
        heartRateDropDate: formatDate(heartRateDropDate),
        anxietyDate: formatDate(anxietyDate),
        symptomsDiminishDate: formatDate(symptomsDiminishDate),
        symptomsDisappearDate: formatDate(symptomsDisappearDate),
      });
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice vous aide à connaître les avantages pour la santé de l'arrêt du tabagisme
                </p>
                <p>
                  Découvrez les trésors cachés de votre santé! Vous vous demandez quels sont les réels avantages de l'arrêt du tabagisme? Cette calculatrice vous aide à explorer les améliorations remarquables qui se produiront dans votre corps et votre esprit. Dès que vous arrêtez de fumer, vous remarquerez une baisse notable de votre fréquence cardiaque et une amélioration de vos niveaux d'anxiété, ainsi que d'autres avantages généraux pour la santé. Commencez votre voyage de récupération de santé dès aujourd'hui!
                </p>
                <p>
                  Êtes-vous prêt à profiter d'une vie plus saine et plus heureuse? L'arrêt du tabagisme est la première étape vers cela. Vous remarquerez une amélioration notable de votre santé générale, y compris l'augmentation de l'énergie et l'amélioration de la respiration. Utilisez cette calculatrice pour estimer les avantages pour la santé que vous obtiendrez. N'oubliez pas que vous n'êtes pas seul et que beaucoup de gens veulent vous aider.
                </p>
                <p>
                  <b>
                    Remarque importante: il faut souligner que cette calculatrice est un outil d'aide uniquement, et que les résultats peuvent différer d'une personne à l'autre. Si vous souhaitez obtenir plus de détails, vous devriez consulter un médecin ou un professionnel de la santé.
                  </b>
                </p>
                <p>
                  La calculatrice a été développée sur la base de{" "}
                  <a
                    href="https://academic.oup.com/ntr/article/9/3/315/1100099"
                    rel="nofollow"
                  >
                    le site académique d'Oxford
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="dose">
                        Nombre de cigarettes par jour
                      </label>
                      <input
                        id="dose"
                        type="number"
                        value={smokePerDay}
                        onChange={(e) => setSmokePerDay(e.target.value)}
                        placeholder="Entrez le nombre de cigarettes"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="numberOfTimes"
                      >
                        Durée du tabagisme (en années)
                      </label>
                      <input
                        id="numberOfTimes"
                        type="number"
                        value={smokingDuration}
                        onChange={(e) => setSmokingDuration(e.target.value)}
                        placeholder="Entrez la durée du tabagisme"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="date">
                        Date d'arrêt
                      </label>
                      <input
                        id="date"
                        type="date"
                        value={quitDate.toISOString().substring(0, 10)}
                        onChange={(e) => setQuitDate(new Date(e.target.value))}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p className="text-white">
                        Années gagnées: {result.lifeGain} années
                      </p>
                      <p className="text-white">
                        La fréquence cardiaque diminue à: {result.heartRateDropDate}
                      </p>
                      <p className="text-white">
                        L'anxiété apparaît à: {result.anxietyDate}
                      </p>
                      <p className="text-white">
                        Les symptômes diminuent à: {result.symptomsDiminishDate}
                      </p>
                      <p className="text-white">
                        Les symptômes disparaissent à: {result.symptomsDisappearDate}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Bnfices de l'arrt du tabac</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>conomies ralises</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmokingRecoveryCalculator;
